import styled from '@emotion/styled';
import useSightStyles from './SightLoading.styles';

interface Props {
	show: boolean;
}

const SightLoading: React.FC<Props> = ({ show }) => {
	const classes = useSightStyles();
	const Keyframes = styled('div')({
		'@keyframes pulsate': {
			from: {
				transform: 'rotate(0deg)',
			},
			to: {
				transform: 'rotate(359deg)',
			},
		},
		animation: 'pulsate 2s infinite ease',
	});
	return show ? (
		<div className={classes.screen}>
			<div className={classes.graphic}>
				<Keyframes>
					<img
						className={classes.picture}
						src="/Logo Coordinadora blanco.png"
						alt="cargando"
					/>
				</Keyframes>

				<p className={classes.paragraph}>Cargando...</p>
			</div>
		</div>
	) : null;
};

export default SightLoading;
